<template>
  <div class="d-flex h-100 align-items-center">
    <div class="content p-4 w-100 justify-content-center text-center" >
      <div class="d-inline-block user-role-autocomplete" v-if="!loading">
        <UserRoleAutoComplete
            class="w-100"
            v-model="selected"
            :initialRoleId="selected?.id"
            :clearable="true"
        />
        <div class="d-flex justify-content-end">
          <v-btn
            class="mr-5 ma-2 exec-btn"
            @click="handleSelectRole"
            :disabled="!selected"
            :style="{
              backgroundColor: loading ? '#B3B8BB' : '',
            }"
          >
            {{ i18n.global.t('common.selectBtn') }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import i18n from '@/lang/i18n';
import { ref, onMounted } from 'vue';
import SelectRoleChecker from '@/router/selectRoleChecker';
import AuthorityCacheApi from '@/services/models/AuthorityCacheApi';
import UserRoleAutoComplete from '@/components/AutoCompletes/UserRoleAutoComplete.vue';
import Role from '@/types/SelfRole';
import { useRouter } from 'vue-router'
const router = useRouter()

const selected = ref<Role>();
const loading = ref(true);

onMounted(() => {
  getSelfRoles()
});

async function getSelfRoles() {
  const res = await SelectRoleChecker.getSelfRoles();
  const count = await SelectRoleChecker.getRoleCount();
  if (count == 1) {
    SelectRoleChecker.selectRole(res[0])
    await AuthorityCacheApi.reflesh()
    redirectRoot()
  } else {
    loading.value = false
  }
}

async function handleSelectRole() {
  if (selected.value) {
    SelectRoleChecker.selectRole(selected.value)
    await AuthorityCacheApi.reflesh()
    redirectRoot()
  }
}

function redirectRoot() {
  router.replace('/')
}

</script>

<style scope>
.user-role-autocomplete {
  width: 40%;
}

.user-role-button {

}
</style>
